import { actionConst } from "../constants";

export const updateShowHeaderBorder = (isShown: boolean) => {
  return {
    type: actionConst.UPDATE_SHOW_HEADER_BORDER,
    isShown,
  };
};
